"use client";

import { ShippingSiteItemsListCard } from "@/components/backoffice/system/configurable-lists/shipping-site-items-list-card";
import { VehicleBrandItemsListCard } from "@/components/backoffice/system/configurable-lists/vehicle-brand-items-list-card";
import { BodyTypeItemsListCard } from "@/components/backoffice/system/configurable-lists/body-type-items-list-card";
import { NonVwfsLessorItemsListCard } from "@/components/backoffice/system/configurable-lists/non-vwfs-lessor-items-list-card";
import { AvsKvpsItemsListCard } from "@/components/backoffice/system/configurable-lists/avs-kvps-items-list-card";
import { AvsInternalAccountItemsListCard } from "@/components/backoffice/system/configurable-lists/avs-internal-account-items-list-card";
import { RestrictedCathrinUserItemsListCard } from "@/components/backoffice/system/configurable-lists/restricted-cathrin-user-items-list-card";
import { InternalAccountItemsListCard } from "@/components/backoffice/system/configurable-lists/internal-account-items-list-card";
import { useSession } from "next-auth/react";
function AdministrationConfigurableLists() {
  const { data: session } = useSession();
  let isRestrictedCathrinUserAdministrator = false;
  if (session && session.user && session.user.id) {
    isRestrictedCathrinUserAdministrator = ["dpsk19i", "dpfvf27"].includes(
      session.user.grpId,
    );
  }
  return (
    <div className="grid grid-cols-2 gap-8">
      <VehicleBrandItemsListCard />
      <AvsKvpsItemsListCard />
      <AvsInternalAccountItemsListCard />
      <ShippingSiteItemsListCard />
      <BodyTypeItemsListCard />
      <NonVwfsLessorItemsListCard />
      {isRestrictedCathrinUserAdministrator && (
        <RestrictedCathrinUserItemsListCard />
      )}
      <InternalAccountItemsListCard />
    </div>
  );
}
export { AdministrationConfigurableLists };
